import axios from './axiosConfig';

//const API_URL = "https://api.demo1.raborisk.ai";

const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo1.raborisk.ai" 
    : "http://localhost:3000";


export const editNotificationUser = (department_id, user_id, notify_assign_task, notify_deadline, notify_comment, notify_delete_risk, notify_delete_control, notify_delete_action, notify_modify_timeline) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/edit_notification_user", { department_id, user_id, notify_assign_task, notify_deadline, notify_comment, notify_delete_risk, notify_delete_control, notify_delete_action, notify_modify_timeline })
            .then(({ data }) => {
                dispatch({ type: "NOTIFICATIONS_SETTINGS", notifications: data });
            });
    };
};

export const removeNotificationUser = (department_id, user_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/remove_notification_user", { department_id, user_id })
            .then(({ data }) => {
                dispatch({ type: "NOTIFICATIONS_SETTINGS", notifications: data });
            });
    };
};

export const addNotificationUser = (department_id, user_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/add_notification_user", { department_id, user_id })
            .then(({ data }) => {
                dispatch({ type: "NOTIFICATIONS_SETTINGS", notifications: data });
            });
    };
};


export const getNotificationsSettings = (department_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/department/get_notifications_settings/" + department_id)
            .then(({ data }) => {
                dispatch({ type: "NOTIFICATIONS_SETTINGS", notifications: data });
            });
    };
};

export const getDepartmentName = async (department_id) => {
    const { data } = await axios.get(API_URL + "/api/department/get_department_name/" + department_id);
    return data;
};

export const getAllDepartments = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/department/get_all_departments")
            .then(({ data }) => {
                ////console.log("All Depts", data);
                dispatch({ type: "ALL_DEPARTMENTS", all_departments: data.departments });
            })
            .catch((error) => {
                console.error("Error fetching departments:", error);
            });
    };
};




export const openDepartmentDashboard = (department_id) => {
    return { type: "OPEN_DEPARTMENT_DASHBOARD", department_id };
};

export const resetDepartmentDashboard = () => {
    return { type: "RESET_DEPARTMENT_DASHBOARD" };
};


export const editActionComments = (comment_iid, comments, department_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/edit_action_comments", { comment_iid, comments, department_id })
            .then(({ data }) => {
                ////console.log("edit comment:" , data)
                dispatch({ type: "ACTIONS", actions: data });
            });
    };
};

export const addActionComments = (action_id, comments, department_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/add_action_comments", { action_id, comments, department_id })
            .then(({ data }) => {
                ////console.log("edit comment:" , data)
                dispatch({ type: "ACTIONS", actions: data });
            });
    };
};


export const getDepartmentsAction = (department_id) => {
    //console.log("department_id", department_id)
    return (dispatch) => {
        axios.get(API_URL + "/api/department/get_departments_actions/" + department_id)
            .then(({ data }) => {
                //console.log("get Actions:" , data)
                dispatch({ type: "ACTIONS", actions: data });
            });
    };
};

export const getDepartmentsActionData = (department_id) => {
  return (dispatch) => {
    ////console.log("department_id", department_id);
    // return the whole axios chain
    return axios
      .get(API_URL + "/api/department/get_departments_actions_data/" + department_id)
      .then(({ data }) => {
        ////console.log("get Actions:", data);
        dispatch({ type: "ACTIONS_DATA", actions: data });
        return data; // now this will be available to the caller
      });
  };
};

export const getDepartmentsFindings = (department_id) => {
  return (dispatch) => {
    ////console.log("department_id", department_id);
    return axios
      .get(API_URL + "/api/department/get_departments_findings/" + department_id)
      .then(({ data }) => {
        //console.log("get Findings:", data);
        dispatch({ type: "FINDINGS_DATA", findings: data });
        return data; // available to the caller
      })
      .catch((err) => {
        console.error("Error fetching findings:", err);
        throw err;
      });
  };
};


export const getProcedures = (department_id) => {
  return (dispatch) => {
    ////console.log("Calling Get");

    return axios
      .post(`${API_URL}/api/department/get_procedures`, { department_id })
      .then(({ data }) => {
        //console.log("Calling Get Results", data);
        dispatch({ type: "POLICIES", departments: data});
        return data;
      })
      .catch((error) => {
        console.error("getProcedures error:", error);
        throw error;  
      });
  };
};

export const getProceduresCompliance = (compliance_id) => {
  return (dispatch) => {
    return axios
      .post(`${API_URL}/api/department/get_procedures`, { compliance_id })
      .then(({ data }) => {
        //console.log("Calling Get Results", data);
        dispatch({ type: "POLICIES_GET", departments: data.combined, compliances: data.policies });
        return data;
      })
      .catch((error) => {
        console.error("getProceduresCompliance error:", error);
        throw error;
      });
  };
};



export const setActiveDepartment = (department_id) => {
    ////console.log("new Dep ", department_id)
    return { type: "SET_ACTIVE_DEPARTMENT", department_id };
};


export const addProcedure = (department_id, data) => {
    //console.log("Adding deparmtned Proc ", department_id)
    return (dispatch) => {
        const details = typeof data === 'string' ? data : (data.details || data.policyName || 'New Policy');
        const payload = typeof data === 'string' 
            ? { department_id, details }
            : {
                department_id,
                details,
                category: data.category || null,
                version: data.version || null,
                status: data.status || 'draft',
                health_level: data.healthLevel || null,
                description: data.description || null,
                compliance_tags: data.complianceTags || null,
                signer_name: data.signer?.name || data.signerName || null,
                signer_role: data.signer?.role || data.signerRole || null,
                signer_signature: data.signer?.signature || data.signature || null,
                signed_date: data.signer?.signedDate || data.signedDate || null
            };
        return axios.post(API_URL + "/api/department/add_procedure", payload)
            .then(({ data }) => {
                dispatch({ type: "POLICIES", departments: data.combined ?? data });
                return data; // so caller can read data.policy_id
            })
            .catch((error) => {
                console.error('addProcedure error:', error);
                throw error;
            });
    };
};

export const addProcedureCompliance = (compliance_id, data) => {
  //console.log("Adding complaince Proc ", compliance_id)
  return (dispatch) => {
    const details =
      typeof data === "string"
        ? data
        : (data.details || data.policyName || "New Policy");

    const payload =
      typeof data === "string"
        ? { compliance_id, details }
        : {
            compliance_id,
            details,
            category: data.category || null,
            version: data.version || null,
            status: data.status || "draft",
            health_level: data.healthLevel || null,
            description: data.description || null,
            compliance_tags: data.complianceTags || null,
            signer_name: data.signer?.name || data.signerName || null,
            signer_role: data.signer?.role || data.signerRole || null,
            signer_signature: data.signer?.signature || data.signature || null,
            signed_date: data.signer?.signedDate || data.signedDate || null,
          };

    return axios
      .post(API_URL + "/api/department/add_procedure", payload)
      .then(({ data }) => {
        dispatch({ type: "POLICIES", departments: data.combined ?? data });
        return data; // caller can read data.policy_id
      })
      .catch((error) => {
        console.error("addProcedureCompliance error:", error);
        throw error;
      });
  };
};


export const updateDepartment = (department_id, data) => {
  return (dispatch) => {
    return axios
      .post(API_URL + "/api/department/update_department", { department_id, data })
      .then(({ data }) => {
        dispatch({ type: "POLICIES", departments: data });
        return data; 
      });
  };
};

export const addCompanyAvatar = (company_id, file) => async (dispatch) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('company_id', company_id);
    await axios.post(API_URL + '/api/department/add_company_avatar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export const updateCompany = (company_id, data) => {
  return (dispatch) => {
    return axios
      .post(API_URL + "/api/department/update_company", { company_id, data })
      .then(({ data }) => {
        dispatch({ type: "COMPANIES", companies: data });
      });
  };
};


export const getCompany = (company_id) => {
  return (dispatch) => {
    axios
      .get(API_URL + `/api/department/get_company/${company_id}`)
      .then(({ data }) => {
        dispatch({ type: "COMPANY", company: data });
      });
  };
};

export const deleteDepartment = (department_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/delete_department", { department_id: department_id })
            .then(({ data }) => {
                dispatch({ type: "DEPARTMENTS", departments: data });
            });
    };
};

export const deleteCompany = (company_id) => {
  return (dispatch) => {
    return axios.post(API_URL + "/api/department/delete_company", { company_id })
      .then(({ data }) => data);
  };
};



export const resetNewlycreatedDepartmentId = () => {
    return { type: "RESET_NEWLYCREATED_DEPARTMENT_ID" };
};


export const resetNewlycreatedCompanyId = () => {
    return { type: "RESET_NEWLYCREATED_COMPANY_ID" };
};
export const createDepartment = (options = {}) => {
    ////console.log("Options ", options)
    return (dispatch) => {
        axios
            .post(API_URL + "/api/department/create_department", options)
            .then(({ data }) => {
                ////console.log("Departments new ", data);
                dispatch({
                    type: "DEPARTMENT_CREATED",
                    departments: data.departments,
                    newlycreatedDepartmentId: data.department_id,
                });
            });
    };
};


export const createCompany = () => {
  return (dispatch) => {
    axios.post(API_URL + "/api/department/create_company")
      .then(({ data }) => {
        ////console.log("Create Company ", data)
        dispatch({
          type: "COMPANY_CREATED",
          companies: data.companies,
          newlyCreatedCompanyId: data.company_id,
        });
      });
  };
};


export const resetDepartment = () => {
    return { type: "RESET_DEPARTMENT" };
};

export const openDepartment = (department_id) => {
    return { type: "OPEN_DEPARTMENT", department_id };
};

export const getDepartments = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/department/get_departments")
            .then(({ data }) => {
                dispatch({ type: "DEPARTMENTS", departments: data });
            });
    };
};

export const getCompanies = () => {
  return (dispatch) => {
    axios.get(API_URL + "/api/department/get_companies")
      .then(({ data }) => {
        ////console.log("Copmanies ", data)
        dispatch({ type: "COMPANIES", companies: data });
      });
  };
};


export const addAttachment = (department_id, policy_id, file) => {
    return (dispatch) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('department_id', department_id);
        formData.append('policy_id', policy_id);
        ////console.log("Here ADd aTachment")
        axios.post(API_URL + "/api/department/add_attachment_procedure", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(({ data }) => {
                dispatch({ type: "POLICIES", departments: data });
            })
            .catch(error => {
                console.error('Error uploading file:', error);
            });
    };
};

export const editProcedure = (department_id, policy_id, policy) => {
    return (dispatch) => {
        return axios.post(API_URL + "/api/department/edit_procedure", { department_id: department_id, policy_id: policy_id, policy: policy })
            .then(({ data }) => {
                //dispatch({ type: "POLICIES", departments: data });
                return data;
            });
    };
};

// frontend helper (matches your axios style)
export const updatePolicyAIScore = (
  department_id,
  policy_id,
  aiResult // <-- pass the FULL AI response object
) => {
  return (dispatch) => {
    return axios
      .post(
        `${API_URL}/api/department/update_policy_ai_score`,
        {
          department_id,
          policy_id,
          ai_health_score: aiResult.healthScore,
          ai_compliance_score: aiResult.Compliance,
          ai_completeness_score: aiResult.Completeness,
          ai_clarity_score: aiResult.Clarity,
          ai_recommendations: aiResult.AIRecommendations
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .then(({ data }) => {
        // backend returns combined departments + policies (same as before)
        return data;
      })
      .catch((error) => {
        console.error("updatePolicyAIScore error:", error);
        throw error;
      });
  };
};

export const updatePolicyAIScoreCompliance = (
  compliance_id,
  policy_id,
  aiResult // full AI response object
) => {
  return (dispatch) => {
    return axios
      .post(
        `${API_URL}/api/department/update_policy_ai_score`,
        {
          compliance_id,
          policy_id,
          ai_health_score: aiResult.healthScore,
          ai_compliance_score: aiResult.Compliance,
          ai_completeness_score: aiResult.Completeness,
          ai_clarity_score: aiResult.Clarity,
          ai_recommendations: aiResult.AIRecommendations,
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        console.error("updatePolicyAIScoreCompliance error:", error);
        throw error;
      });
  };
};



export const deleteProcedure = (department_id, policy_id) => {
    return (dispatch) => {
        return axios.post(API_URL + "/api/department/delete_procedure", { department_id: department_id, policy_id: policy_id })
            .then(({ data }) => {
                dispatch({ type: "POLICIES", departments: data });
                return data;
            });
    };
};

